module.exports = __webpack_public_path__ + "static/media/issue_update_icon2.b72e48d2.svg";